import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { ItemsCountToClassName } from '../items-count-to-class-name';
import { RouterLink } from '@angular/router';
import { YesCategory } from '../megamenu.types';
import { AddLocalePipe } from '../../../pipes/url-locale.pipe';

@Component({
  selector: 'app-megamenu-subsection',
  imports: [ItemsCountToClassName, RouterLink, AddLocalePipe],
  templateUrl: './megamenu-subsection.component.html',
  styleUrls: ['./megamenu-subsection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenuSubsectionComponent {
  private readonly itemsCountPipe = inject(ItemsCountToClassName);

  @ViewChild(RouterLink, { read: ElementRef })
  private firstLink?: ElementRef<HTMLAnchorElement>;

  @Input()
  subcategory!: YesCategory;

  @Output()
  linkClick = new EventEmitter();

  @HostBinding('class')
  get classes(): string {
    return (
      'subsection ' +
      this.itemsCountPipe.transform(this.subcategory?.children.length ?? 1)
    );
  }

  focus(): void {
    this.firstLink?.nativeElement.focus();
  }
}
